import React, { Component } from 'react';

import '../styles/main.css';

// import Header from './components/common/Header';
// import Sidebar from './components/common/Sidebar';

class App extends Component {
  render() {
    return (
      <div></div>
      // <div id="wrapper">
      //   <Header /> 
      //   <div id="main">
      //     {this.props.children}
      //   </div>
      //   <Sidebar />
      // </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js